import { Suspense, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "Routes";
import { Amplify } from "aws-amplify";
import { poolData } from "shared/components/user-pool/AwsConfig";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedUser } from "explorer/reducers/users";
import { autenticado } from "shared/helpers/auth-functions";
import { loadUserId as initUserId } from "shared/init-functions/browser-id";
import GoogleTag from "shared/components/google-tag";
import Personify from "shared/components/personify/Personify";
import { ToastContainer } from "react-toastify";
import {
  getLoggedUserArtist,
  getUserDistroToken,
} from "explorer/reducers/artistas";
import { getStrmClassVideos } from "explorer/reducers/strm-class";
import { LayoutProvider } from "shared/layout/LayoutProvider";
import { getMonitoredData } from "explorer/reducers/monitored-data";
import { useLDClient } from "launchdarkly-react-client-sdk";
import { UserState } from "explorer/reducers/users";
import { getUserSubscription } from "explorer/reducers/subscription";
import initLDUser from "shared/init-functions/init-ld-user";
import initSentry from "shared/init-functions/init-sentry";
import useI18nOptions from "shared/hooks/useI18nOptions";
import "./App.scss";

Amplify.configure(poolData);
initUserId();
initSentry();

function App() {
  const ldClient = useLDClient();
  const dispatch = useDispatch();
  const { loggedUser } = useSelector((state: UserState) => state.users);
  useI18nOptions();

  useEffect(() => {
    initLDUser(loggedUser, ldClient);
  }, [ldClient, loggedUser]);

  useEffect(() => {
    if (autenticado()) {
      dispatch(getLoggedUser());
      dispatch(getLoggedUserArtist());
      dispatch(getStrmClassVideos());
      dispatch(getMonitoredData());
      dispatch(getUserDistroToken());
      dispatch(getUserSubscription());
    }
  }, [dispatch]);

  return (
    <Suspense fallback="loading">
      <LayoutProvider>
        <BrowserRouter>
          <ToastContainer theme="dark" style={{ zIndex: 9999999 }} />
          <Personify />
          <GoogleTag />
          <Routes />
        </BrowserRouter>
      </LayoutProvider>
    </Suspense>
  );
}

export default App;
